import axios from 'axios';
import { logout } from '../store/authSlice';
import { showSnackbar } from '../store/snackbarSlice';

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

// Create axios instance with base URL
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Get token from session storage
    const userData = localStorage.getItem('user');
    if (userData) {
      const { token } = JSON.parse(userData);
      if (token) {
        // Add token to headers
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 403 errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Get the request URL
    const requestUrl = error.config?.url || '';
    
    // Check if this is an auth-related endpoint
    const isAuthEndpoint = 
      requestUrl.includes('/user/signin') || 
      requestUrl.includes('/user/signup') || 
      requestUrl.includes('/user/verify-email') ||
      requestUrl.includes('/user/resend-verification') ||
      requestUrl.includes('/user/request-password-reset') ||
      requestUrl.includes('/user/password-reset');
    
    // Only handle 403 with session expiry for non-auth endpoints
    if (error.response?.status === 403 && !isAuthEndpoint) {
      console.log('Session expired, logging out...');
      
      // Dynamically import store to avoid circular dependency
      import('../store/index').then(({ store }) => {
        // Dispatch logout action
        store.dispatch(logout());
        
        // Show error message
        store.dispatch(showSnackbar({
          message: 'Session expired. Please sign in again.',
          severity: 'error'
        }));
      });

      // Navigate to home page
      window.location.href = '/';
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance; 